<template>
<div>
  <div class="container-fluid">
    <div class="row mt17">
      <div class="col-lg-12 col-md-12">
        <div class="card card-nav-tabs">
          <div class="card-header gradient-npo">
            <span class="title" style="display:inline-block">{{ $t('donations.id_donation') + ': ' + route.params.id }}</span>
          </div>
          <div class="card-content">
            <div class="row">
              <div class="col-xs-8 transaction-details">
                <div class="row">
                  <div class="col-md-6">
                    <li>{{$t('donations.date')}}:</li>
                    <p>
                      <strong>{{date}}</strong>
                    </p>
                  </div>
                  <div class="col-md-6">
                    <li>{{$t('donations.amount')}}:</li>
                    <p class="amount">
                      <strong>{{donation.amount + ' €'}}</strong>
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-xs-4" style="text-align:right">
                <p>{{$t('donations.amount_avg')}}</p>
                <p class="amount">
                  <strong>{{(donation.amount/donation.payments.length).toFixed(2) + ' €'}}</strong>
                </p>
                <p class="status">{{$t('donations.payments_num')}}</p>
                <p>
                    <strong>{{donation.payments.length}}</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <data-table
          :title="title"
          :tableHeaders="tableHeaders"
          :radioFilter="radioFilter"
          :getData="getPayments"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import DataTable from '@/components/shared/dataTable/DataTable'
import DatesFilter from '@/components/shared/inputs/DatesFilter'
import apiService from '@/services/ApiService'
import formatter from '@/mixins/Formatter'
import moment from 'moment'
import { donationDetails as dataTable } from '@/components/npos/tables/settings'

export default {
  name: 'npo-donation-details',
  components: {
    DataTable,
    DatesFilter
  },
  mixins: [formatter],
  props: ['id'],
  data() {
    return {
      title: this.$t('labels.donations'),
      ...dataTable
    }
  },
  methods: {
    ...mapMutations({
      goTo: 'goTo'
    }),
    getPayments: function(page, filters) {
      return apiService.getDonation(this.id, {
        page: page - 1,
        ...filters,
        filters: JSON.stringify(filters.filters)
      })
    }
  },
  computed: {
    ...mapState({
      route: state => state.route,
      donation: state => state.selectedDonation
    }),
    date: function() {
      return moment(this.donation.date).format('DD MMM YYYY')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/config.scss';

.i-b {
  display: inline-block;
}

li {
  list-style: none;
}

p.value {
  color: #202020;
  font-weight: bold;
}

.header-action {
  margin: auto;
  color: white;
}

.card .title {
  color: $white;
  @include normalFontSize();
  line-height: 14px;
  margin-right: 8px;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/npos/DonationDetails.vue